import {
  ApplicationIdPathParam,
  IfpApplicationActionPathParams,
  IfpCreateApplicationRequest,
  IfpCreateApplicationResponse,
  IfpGetApplicationResponse,
  IfpUpdateApplicationRequest,
} from '@shared/sec-loans'
import { Endpoint } from '@shared/types'

export const ENDPOINT_IFP_GET_APPLICATION: Endpoint<IfpGetApplicationResponse, void, never, ApplicationIdPathParam> = {
  path: '/ifp/application/{applicationId}',
  method: 'get',
}

export const ENDPOINT_IFP_CREATE_APPLICATION: Endpoint<IfpCreateApplicationResponse, IfpCreateApplicationRequest> = {
  path: '/ifp/application',
  method: 'post',
}

export const ENDPOINT_IFP_UPDATE_APPLICATION: Endpoint<
  void,
  IfpUpdateApplicationRequest,
  never,
  ApplicationIdPathParam
> = {
  path: '/ifp/application/{applicationId}',
  method: 'put',
}

export const ENDPOINT_IFP_APPLICATION_ACTION: Endpoint<void, void, never, IfpApplicationActionPathParams> = {
  path: '/ifp/application/{applicationId}/action/{action}',
  method: 'put',
}
